import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _Immutable$Map;

import Immutable from 'immutable';
import { DEV, PROD, STG } from "./environments";
export default Immutable.Map((_Immutable$Map = {}, _defineProperty(_Immutable$Map, DEV, Immutable.Map({
  indexName: 'marketplace_plugins_dev'
})), _defineProperty(_Immutable$Map, STG, Immutable.Map({
  indexName: 'marketplace_plugins_stg'
})), _defineProperty(_Immutable$Map, PROD, Immutable.Map({
  indexName: 'marketplace_plugins_prod'
})), _Immutable$Map));